import { render } from "./ReportProseField.vue?vue&type=template&id=543004a8"
import script from "./ReportProseField.vue?vue&type=script&lang=js"
export * from "./ReportProseField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__